<style>
.th-col {
  font-weight: bold;
  background-color: gainsboro;
  font-size: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.td-col {
  font-size: 15px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.td-col-dia {
  font-size: 15px;
  background-color: #e2fcf6;
  padding-top: 4px;
  padding-bottom: 4px;
}
input[type="text"] {
  height: 30px;
  font-size: 12px;
}
.col-total {
  padding-top: 10px;
}
label {
  font-size: 12px;
  font-weight: bold;
}
.tooltip {
  max-width: 300px; /* Define el ancho máximo del tooltip */
}
/* .row-operation-header {
  width: 1650px;
}
.row-operation-detail{
  width: 1630px;
} */
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card>
      <b-card-header header-tag="header" class="p-1" role="tab">Adelanto de Cobros</b-card-header>

      <b-card-body v-if="model.MostrarMensajeResuesta">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="model.resultadoRespuesta.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px;">
                <i :class="model.resultadoRespuesta.Icono"></i>
              </span>
              <br />
              <span class="alert-inner--text" v-html="model.resultadoRespuesta.Texto"></span>
            </base-alert>
          </div>
        </div>
        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
      <b-card-body v-else>
        <div class="text-right" style="padding-bottom:5px">
          <button
            class="btn btn-danger"
            type="button"
            @click="GoToConfigurarPlazosAcreditacion()"
          >Configurar Adelanto</button>
        </div>
        <div class="row" style="border: 1px solid #d6d4d4;">
          <div class="col-sm-1" style="padding-top:6px">
            <label>Buscar</label>
          </div>
          <div class="col-sm-3" style="padding-bottom:6px;padding-top:6px">
            <KitsCombo
              v-model="model.searchDate"
              v-bind:items="model.searchDates"
              v-on:input="getAcreditacionesPendientes"
              propertyName="Description"
              propertyID="ID"
            ></KitsCombo>
          </div>
          <!-- <div class="col-sm-2 text-right" style="padding-top:6px">
            <filter-button @click="getAcreditacionesPendientes"></filter-button>
          </div>-->
        </div>

        <div v-if="model.isAutomaticConfiguration == false">
          <div class="row" style="padding-bottom:30px"></div>

          <div v-if="this.model.listPerDayLenght == 0" class="text-center">
            <div>No se encontraron registros</div>
            <img src="/img/ic_no_resultado.png" style="width: 200px;" />
          </div>
          <div
            v-else
            style="overflow-y:scroll;max-height: 370px;overflow-y: auto;overflow-x:hidden"
          >
            <div class="row" style="padding-right:15px;">
              <div class="col-2 text-center th-col">Fecha</div>
              <div class="col-3 text-center th-col">Importe a Adelantar</div>
              <div class="col-3 text-center th-col">Importe a Acreditar</div>
              <div class="col-4 text-center th-col"></div>
            </div>
            <div
              v-for="itemDay in this.model.listPerDay"
              v-bind:key="'day' + itemDay.Id"
              @click="showPendingAccreditationsClick(itemDay)"
              style="border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
            >
              <div
                class="row"
                style="border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-2 text-center td-col-dia">{{itemDay.FormattedDate}}</div>
                <div class="col-3 text-center td-col-dia">{{itemDay.FormattedAmountToCredit}}</div>
                <div class="col-3 text-center td-col-dia">{{itemDay.FormattedAmountToAdvance}}</div>
                <div class="col-4 text-center td-col-dia">
                  <i :class="itemDay.CompressExpandRowIcon" style="color:DodgerBlue"></i>
                </div>
              </div>
              <div
                class="row row-operation-header"
                style="padding-right:15px;"
                v-show="itemDay.ShowPendingAccreditations"
                @click="showPendingAccreditationsClick(itemDay)"
              >
                <div class="col text-center th-col">
                  <input type="checkbox" @change="checkAll(itemDay)" v-model="itemDay.Checked" /> Nro. Operación
                </div>
                <div class="col text-right th-col">Importe</div>
                <div class="col text-center th-col">Medio de Pago</div>
                <div class="col text-center th-col">Cuotas</div>
                <div class="col text-center th-col">Fecha de Cobro</div>
                <div class="col text-center th-col">Dias de Adelanto</div>
                <div class="col text-center th-col">Comisión por Operación</div>
                <div class="col text-center th-col">Comisión por Adelanto</div>
                <div class="col text-center th-col">Importe a Acreditar</div>
              </div>
              <div v-show="itemDay.ShowPendingAccreditations">
                <div
                  class="row row-operation-detail"
                  v-for="item in itemDay.pendingAccreditations"
                  v-bind:key="'pendingAcreditation'+item.Id"
                  @click="showPendingAccreditationsClick(itemDay)"
                  style="border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
                >
                  <div
                    class="col text-left td-col"
                    style="padding-left:20px"
                    v-b-tooltip.hover
                    :title="item.TransactionPlatformID"
                  >
                    <input
                      v-if="item.AdvanceEnabled"
                      type="checkbox"
                      v-bind:key="'pendingAcreditationCheck'+item.id"
                      v-model="item.Checked"
                      @change="checkItem()"
                    />
                    {{getFormattedTransactionPlatformID(item)}}
                  </div>
                  <div class="col text-right td-col">{{item.FormattedAmount}}</div>
                  <div class="col text-center td-col">{{item.OperationType}}</div>
                  <div class="col text-center td-col">{{item.Dues}}</div>
                  <div class="col text-center td-col">{{item.FormattedPaymentDate}}</div>
                  <div class="col text-center td-col">{{item.DaysInAdvance}}</div>
                  <div class="col text-right td-col">{{item.FormattedOperationComissionAmount}}</div>
                  <div class="col text-right td-col">{{item.FormattedAdvanceCommisionAmount}}</div>
                  <div class="col text-right td-col">{{item.FormattedAmountToAdvance}}</div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="this.model.listPerDayLenght > 0"
            class="row"
            style="border: 1px solid #d6d4d4;margin-top: 30px"
          >
            <div class="col-md-2 text-center col-total">
              <label>Importe Total</label>
              <input
                type="text"
                class="form-control text-right"
                readonly
                v-model="model.total.total"
              />
            </div>
            <div class="col-md-2 text-center col-total">
              <label>Comisión por Operación</label>
              <input
                type="text"
                class="form-control text-right"
                readonly
                v-model="model.total.comisionPorOperacion"
              />
            </div>
            <div class="col-md-2 text-center col-total">
              <label>Comisión por Adelanto</label>
              <input
                type="text"
                class="form-control text-right"
                readonly
                v-model="model.total.comisionPorAdelanto"
              />
            </div>
            <div class="col-md-2 text-center col-total">
              <label>Total a Acreditar</label>
              <input
                type="text"
                class="form-control text-right"
                readonly
                v-model="model.total.totalAdelantar"
                style="font-weight: bold"
              />
            </div>
            <div class="col-md-3 text-right" style="margin-top: 27px; margin-bottom:15px">
              <button
                :disabled="!model.anyPendingAccreditationsSelected || !model.IsAdvanceEnabled"
                class="btn btn-success"
                type="button"
                @click="adelantarOperaciones()"
              >
                <i class="fa fa-angle-double-right fa-fw"></i>Adelantar
              </button>
            </div>
          </div>
        </div>

        <div v-if="model.isAutomaticConfiguration" style="padding-top:20px">
          <strong>{{model.activeAutomaticConfigurationMessage}}</strong>
        </div>

        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import confirmHelper from "@/helpers/confirmHelpers";
import KitsDate from "@/components/KitsDate";
import KitsCombo from "@/components/KitsCombo";
import DateTime from "luxon/src/datetime.js";

export default {
  components: { KitsDate, KitsCombo },
  data() {
    return {
      model: {
        searchDate: 3,
        searchDates: [
          { ID: 1, Description: "Mañana" },
          { ID: 2, Description: "Próximos 3 días" },
          { ID: 3, Description: "Próximos 7 días" },
          { ID: 4, Description: "Todo" }
        ],
        pendingRefundAmount: 0,
        IsAdvanceEnabled: false,
        total: {
          total: "",
          comisionPorOperacion: "",
          comisionPorAdelanto: "",
          totalAdelantar: ""
        },
        MostrarMensajeResuesta: false,
        resultadoRespuesta: {
          Texto: "",
          Tipo: "",
          Icono: "",
          Exito: false
        },
        listPerDay: [],
        listPerDayLenght: 0,
        anyPendingAccreditationsSelected: false,
        isAutomaticConfiguration: false,
        activeAutomaticConfigurationMessage: ""
      }
    };
  },
  methods: {
    getInitialDate() {
      var dt = DateTime.local();
      var ret = DateTime.local(parseInt(dt.year) - 1, 1, 1, 0, 0);
      return ret.toString();
    },
    getDayFromToday(daysNumber) {
      var dt = DateTime.local().plus({ days: daysNumber });
      var ret = DateTime.local(dt.year, dt.month, dt.day, 0, 0);
      return ret.toString();
    },
    getInitialSearchDate() {
      if (
        this.model.searchDate == 1 ||
        this.model.searchDate == 2 ||
        this.model.searchDate == 3
      )
        return this.getInitialDate();
      else return null;
    },
    getSearchDate() {
      if (this.model.searchDate == 1) return this.getDayFromToday(2);
      else if (this.model.searchDate == 2) return this.getDayFromToday(4);
      else if (this.model.searchDate == 3) return this.getDayFromToday(8);
      else return null;
    },
    getAcreditacionesPendientes() {
      let context = this;

      axiosHelpers.axiosGet(
        "OperationsFintouch/GetPendingAccreditationsByCommerce",
        {
          DateFrom: context.getInitialSearchDate(),
          DateTo: context.getSearchDate()
        },
        this,
        function(response) {
          context.model.pendingRefundAmount =
            response.ResponseVM.PendingRefundAmount;
          context.model.IsAdvanceEnabled = response.ResponseVM.IsAdvanceEnabled;
          context.model.isAutomaticConfiguration =
            response.ResponseVM.IsAutomaticConfiguration;
          context.model.activeAutomaticConfigurationMessage =
            response.ResponseVM.ActiveAutomaticConfigurationMessage;

          context.model.listPerDay = [];

          var i = 1;
          response.ResponseVM.ListPerDay.forEach(x => {
            var day = {
              Id: i,
              Date: x.Date,
              FormattedDate: x.FormattedDate,
              FormattedAmountToCredit: x.FormattedAmountToCredit,
              FormattedAmountToAdvance: x.FormattedAmountToAdvance,
              pendingAccreditations: [],
              Checked: false,
              ShowPendingAccreditations: false,
              CompressExpandRowIcon: "fa fa-sort-down"
            };
            i++;
            x.PendingAccreditations.forEach(y => {
              var pendingAccreditation = {
                Id: i,
                OperationID: y.OperationID,
                TransactionCommerceID: y.TransactionCommerceID,
                Amount: y.Amount,
                FormattedAmount: y.FormattedAmount,
                OperationType: y.OperationType,
                FormattedPaymentDate: y.FormattedPaymentDate,
                FormattedRelaseDate: y.FormattedReleaseDate,
                TransactionCommissionValue: y.TransactionCommissionValue,
                TransactionPlatformID: y.TransactionPlatformID,
                AdvanceCommissionValue: y.AdvanceCommissionValue,
                DaysInAdvance: y.DaysInAdvance,
                AmountToCredit: y.AmountToCredit,
                AmountToAdvance: y.AmountToAdvance,
                Checked: false,
                Dues: y.Dues,
                AdvanceEnabled: y.AdvanceEnabled,

                FormattedOperationComissionAmount: context.getFormattedAmount(
                  -y.TransactionCommissionValue
                ),
                FormattedAdvanceCommisionAmount: context.getFormattedAmount(
                  -y.AdvanceCommissionValue
                ),
                FormattedAmountToCredit: context.getFormattedAmount(
                  y.AmountToCredit
                ),
                FormattedAmountToAdvance: context.getFormattedAmount(
                  y.AmountToAdvance
                )
              };
              i++;
              day.pendingAccreditations.push(pendingAccreditation);
            });
            context.model.listPerDay.push(day);
          });
          context.model.listPerDayLenght = context.model.listPerDay.length;

          context.model.listPerDay.sort((a, b) => {
            return new Date(a.Date) - new Date(b.Date);
          });

          context.CalcularTotales();
        }
      );
    },
    CalcularTotales() {
      let context = this;

      var total = 0;
      var comisionPorOperacion = 0;
      var comisionPorAdelanto = 0;
      var totalAdelantar = 0;

      context.model.listPerDay.forEach(itemDay => {
        itemDay.pendingAccreditations.forEach(item => {
          if (item.Checked) {
            total = total + item.Amount;
            comisionPorOperacion =
              comisionPorOperacion + item.TransactionCommissionValue;
            comisionPorAdelanto =
              comisionPorAdelanto + item.AdvanceCommissionValue;
            totalAdelantar = totalAdelantar + item.AmountToAdvance;
          }
        });
      });

      context.model.total.total = context.getFormattedAmount(total);
      context.model.total.comisionPorOperacion = context.getFormattedAmount(
        -comisionPorOperacion
      );
      context.model.total.comisionPorAdelanto = context.getFormattedAmount(
        -comisionPorAdelanto
      );
      context.model.total.totalAdelantar = context.getFormattedAmount(
        totalAdelantar
      );

      if (totalAdelantar == 0)
        context.model.anyPendingAccreditationsSelected = false;
      else context.model.anyPendingAccreditationsSelected = true;
    },
    getFormattedTransactionPlatformID(item) {
      return item.TransactionPlatformID.slice(0, 8) + "...";
    },
    getFormattedAmount(amount) {
      return "$" + parseFloat(amount).toFixed(2);
    },
    checkAll(itemDay) {
      itemDay.pendingAccreditations
        .filter(element => element.AdvanceEnabled)
        .forEach(element => {
          element.Checked = itemDay.Checked;
        });

      this.CalcularTotales();
    },
    showPendingAccreditationsClick(itemDay) {
      itemDay.ShowPendingAccreditations = !itemDay.ShowPendingAccreditations;

      if (itemDay.ShowPendingAccreditations)
        itemDay.CompressExpandRowIcon = "fa fa-sort-up";
      else itemDay.CompressExpandRowIcon = "fa fa-sort-down";
    },
    uncheckCheckAll() {
      let context = this;
      context.model.listPerDay.forEach(itemDay => {
        var anySelected = false;
        itemDay.pendingAccreditations.forEach(item => {
          if (item.Checked == true) {
            anySelected = true;
          }
        });

        if (anySelected == false) {
          itemDay.Checked = false;
        }
      });
    },
    checkItem() {
      this.uncheckCheckAll();
      this.CalcularTotales();
    },
    adelantarOperaciones() {
      let context = this;

      var mensajeConfirmacionAdelanto =
        "¿Deseas acreditar " +
        context.model.total.totalAdelantar +
        " a tu cuenta por adelantado?";

      if (context.model.pendingRefundAmount > 0) {
        mensajeConfirmacionAdelanto =
          "Existen operaciones pendientes de devolución por " +
          context.getFormattedAmount(context.model.pendingRefundAmount) +
          " que se descontarán del total a acreditar.\n ¿Desea adelantar las operaciones de todos modos?";
      }

      confirmHelper.showConfirm(mensajeConfirmacionAdelanto, this, function() {
        // -- En caso que la confirmacion sea aceptada

        var acreditacionesPendientesSeleccionadas = [];

        context.model.listPerDay.forEach(itemDay => {
          itemDay.pendingAccreditations.forEach(item => {
            if (item.Checked) {
              acreditacionesPendientesSeleccionadas.push(
                parseInt(item.OperationID)
              );
            }
          });
        });

        if (acreditacionesPendientesSeleccionadas.length > context.$store.getters.FINTOUCH_MAX_OP_ADELANTO) {
          notificationHelpers.showWarning(
            "Advertencia",
            "No se pueden adelantar las operaciones. El máximo permitido es: " + context.$store.getters.FINTOUCH_MAX_OP_ADELANTO,
            context
          );
          return;
        }

        axiosHelpers.axiosPost(
          "OperationsFintouch/AdvancePendingAccreditations",
          {
            FintouchOperationIDList: acreditacionesPendientesSeleccionadas
          },
          context,
          function(data) {
            context.model.MostrarMensajeResuesta = true;
            if (data.ResponseVM.Success) {
              context.model.resultadoRespuesta = {
                Texto: "Operación realizada con éxito!",
                Tipo: "success",
                Icono: "fa fa-fw fa-check-circle",
                Exito: true
              };
            } else if (data.Alerts.length > 0) {
              context.model.resultadoRespuesta = {
                Texto: data.Alerts[0].Message,
                Tipo: "danger",
                Icono: "fa fa-fw fa-times-circle",
                Exito: false
              };
            }
          }
        );
      });
    },
    goBack() {
      this.$router.push("SmartPost");
    },
    GoToConfigurarPlazosAcreditacion() {
      let context = this;

      context.$router.push({
        name: "ConfigurarPlazosAcreditacion"
      });
    }
  },
  beforeMount() {},
  mounted() {
    this.getAcreditacionesPendientes();
  }
};
</script>